import { CloudOff, Loader2 } from 'lucide-react';
import { TextField } from '@/shared/components/form/text-field';
import { useOnline } from '@/shared/hooks/use-online';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Button } from '@/shared/ui/button/button';
import { useLoginForm } from '../hooks/use-login-form';

type LoginFormProps = {
  readonly login?: string;
};

export function LoginForm({ login: initialLogin = '' }: LoginFormProps) {
  const online = useOnline();
  const { t } = useTranslation();
  const form = useLoginForm(initialLogin);
  return (
    <form onSubmit={(event) => void form.submit(event)} className="flex flex-col gap-4">
      <TextField
        label={t('Email or username')}
        value={form.login}
        onChange={form.setLogin}
        autoComplete="username"
        autoFocus={!initialLogin}
      />
      <TextField
        label={t('Password')}
        type="password"
        value={form.password}
        onChange={form.setPassword}
        autoComplete="current-password"
        autoFocus={Boolean(initialLogin)}
      />
      {form.error && (
        <p role="alert" className="text-sm text-destructive">
          {t(form.error)}
        </p>
      )}
      {!online && (
        <p className="flex items-center gap-2 text-sm text-muted-foreground">
          <CloudOff className="size-4" /> {t('Offline')}
        </p>
      )}
      <Button type="submit" size="lg" disabled={form.busy || !form.login || !form.password}>
        {form.busy && <Loader2 className="animate-spin" />} {t('Sign in')}
      </Button>
    </form>
  );
}
